import Swiper, { Navigation, Pagination } from "swiper";
import "swiper/css";

Swiper.use([Navigation, Pagination]);

export default class TestimonialsCarousel {
  constructor() {
    const $elements = document.querySelectorAll(".js-quotes-carousel");

    $elements.forEach(($el) => {
      const carousel = new Swiper($el, {
        loop: true,
        centeredSlides: true,
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
      });
    });
  }
}
